import isString from 'lodash/isString'

const CLASS_NAME = 'dmp-antd-component'

export default (className, customClass = CLASS_NAME) => {
  if (className && isString(className)) {
    return `${customClass} ${className}`
  }
  if (className && Array.isArray(className)) {
    return `${customClass} ${className.join(' ')}`
  }
  return customClass
}
